import * as React from "react";
import ImageView from "../../../../../components/SmartImage";
import { DiscountInfoCard } from "../Components/DiscountInfoCard";
import { NameViews } from "../Components/NameViews";
import { PriceViews } from "../Components/PriceViews";
import { StarsAndSold } from "../Components/StarsAndSold";
import { TwentyFour } from "../Components/TwentyFour";
import { ProductCard, ProductCardPoster, DescriptionWrap } from "./styles";
export const TomatoCardItem = (props) => {
    const { product, imgWidth, placeholderBg = "", posterRatio = 1 } = props;
    const { img = "", name = "", price = "", originPrice = "" } = product;
    const { ltImg = "", rtImg = "", sold = "", star = 0, titleImg = "", twentyTour = "", countdownToEnd = "", } = product.extra;
    return (React.createElement(ProductCard, { target: "_blank", width: imgWidth, href: product.url },
        React.createElement(ProductCardPoster, { style: {
                background: `url(${placeholderBg}) center`,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                width: imgWidth,
                height: imgWidth * posterRatio,
            } },
            React.createElement(DiscountInfoCard, { ltImg: ltImg, rtImg: rtImg, countdownToEnd: countdownToEnd }),
            React.createElement(ImageView, { src: img, style: { borderRadius: "6px 6px 0 0" }, online: true, fit: true })),
        React.createElement(DescriptionWrap, null,
            React.createElement(NameViews, { name: name, activeImg: titleImg }),
            React.createElement(PriceViews, { price: price, originPrice: originPrice }),
            React.createElement(StarsAndSold, { sold: sold, star: star }),
            React.createElement(TwentyFour, { text: twentyTour }))));
};
